import { render } from "./TrendChart.vue?vue&type=template&id=40da5b50&scoped=true"
import script from "./TrendChart.vue?vue&type=script&lang=js"
export * from "./TrendChart.vue?vue&type=script&lang=js"

import "./TrendChart.vue?vue&type=style&index=0&id=40da5b50&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40da5b50"]])

export default __exports__